<h1 mat-dialog-title>Edit Applicant: {{ user.realName }}</h1>
<mat-dialog-content [formGroup]="form">
  <p>Make minor corrections to this applicant. Changes will be recorded in the audit log.</p>
  <p><i>Identity</i></p>
  <mat-form-field appearance="fill">
    <mat-label>Real name</mat-label>
    <input type="text" matInput formControlName="realName" required>
  </mat-form-field>
  <app-locationpicker [formGroup]="form" [forUser]=true></app-locationpicker>
  <mat-form-field appearance="fill">
    <mat-label>In-person escape rooms played</mat-label>
    <input type="number" matInput formControlName="irlRoomCount" required>
    <mat-error *ngIf="form.controls.irlRoomCount.hasError('min')">
      Number of games played must be greater than zero.
    </mat-error>
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Bio</mat-label>
    <textarea matInput formControlName="bio" required
              cdkTextareaAutosize #autosize="cdkTextareaAutosize" cdkAutosizeMinRows="3"></textarea>
  </mat-form-field>
  <p><i>Social Media</i></p>
  <mat-form-field appearance="fill">
    <mat-label>Facebook userid</mat-label>
    <input type="text" matInput formControlName="facebookUsername">
    <mat-error *ngIf="form.controls.facebookUsername.hasError('pattern')">
      Invalid Facebook userid. If the URL is <i>facebook.com/john.doe7</i>, enter <i>john.doe7</i>.
    </mat-error>
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Instagram userid</mat-label>
    <input type="text" matInput formControlName="instagramUsername">
    <mat-error *ngIf="form.controls.instagramUsername.hasError('pattern')">
      Invalid Instagram userid. If the URL is <i>instagram.com/john.doe7</i>, enter <i>john.doe7</i>.
    </mat-error>
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Discord username</mat-label>
    <input type="text" matInput formControlName="discordUsername">
    <mat-error *ngIf="form.controls.discordUsername.hasError('pattern')">
      Invalid Discord username.
    </mat-error>
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>LinkedIn userid</mat-label>
    <input type="text" matInput formControlName="linkedinUsername">
    <mat-error *ngIf="form.controls.linkedinUsername.hasError('pattern')">
      Invalid LinkedIn userid. If the URL is <i>linkedin.com/in/john-doe</i>, enter <i>john-doe</i>.
    </mat-error>
  </mat-form-field>
  <p><i>Room-Tracking Accounts</i></p>
  <mat-form-field appearance="fill">
    <mat-label>Morty username</mat-label>
    <input type="text" matInput formControlName="mortyAppUsername">
    <mat-error *ngIf="form.controls.mortyAppUsername.hasError('pattern')">
      Invalid Morty username.
    </mat-error>
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>EscapeTheReview.co.uk userid</mat-label>
    <input type="text" matInput formControlName="escapeTheReviewUserId">
    <mat-error *ngIf="form.controls.escapeTheReviewUserId.hasError('pattern')">
      Invalid EscapeTheReview userid.
    </mat-error>
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>EscapeAll.gr userid</mat-label>
    <input type="text" matInput formControlName="escapeAllGrUserId">
    <mat-error *ngIf="form.controls.escapeAllGrUserId.hasError('pattern')">
      Invalid EscapeAll.gr userid.
    </mat-error>
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>EscapeGame.fr userid</mat-label>
    <input type="text" matInput formControlName="escapeGameFrUserId">
    <mat-error *ngIf="form.controls.escapeGameFrUserId.hasError('pattern')">
      Invalid EscapeGame.fr userid.
    </mat-error>
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Escape-Roomers.com userid</mat-label>
    <input type="text" matInput formControlName="escapeRoomersUserId">
    <mat-error *ngIf="form.controls.escapeRoomersUserId.hasError('pattern')">
      Invalid Escape-Roomers.com userid.
    </mat-error>
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>EscapeTalk.nl userid</mat-label>
    <input type="text" matInput formControlName="escapeTalkNlUserId">
    <mat-error *ngIf="form.controls.escapeTalkNlUserId.hasError('pattern')">
      Invalid EscapeTalk.nl userid.
    </mat-error>
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>Lockme userid</mat-label>
    <input type="text" matInput formControlName="lockMeUserId">
    <mat-error *ngIf="form.controls.lockMeUserId.hasError('pattern')">
      Invalid Lockme userid.
    </mat-error>
  </mat-form-field>
  <mat-form-field appearance="fill">
    <mat-label>The-Escapers.com userid</mat-label>
    <input type="text" matInput formControlName="theEscapersUserId">
    <mat-error *ngIf="form.controls.theEscapersUserId.hasError('pattern')">
      Invalid The-Escapers.com userid.
    </mat-error>
  </mat-form-field>
</mat-dialog-content>
<div mat-dialog-actions align="end">
  <button mat-raised-button color="secondary" (click)="cancel()">
    Cancel
  </button>
  <button mat-raised-button color="primary" (click)="submit()" [disabled]="!formIsValid()">
    Save Changes
  </button>
</div>
